import { Flex, Image } from '@mantine/core'
import MTLLOGO from '../../images/MTLLOGO.svg'
export function Logo(props: React.ComponentPropsWithoutRef<'svg'>) {
    return (
        <Flex justify='center' wrap='nowrap' align='center' gap='sm'>
            <Image src={MTLLOGO} width={50} w='50px' />
        </Flex>
    )
}
